module.exports = __webpack_public_path__ + "img/return-parcel-delivered.333c579b.svg";